import { render, staticRenderFns } from "./ordersum.vue?vue&type=template&id=4d2b3ade&scoped=true&"
import script from "./ordersum.vue?vue&type=script&lang=js&"
export * from "./ordersum.vue?vue&type=script&lang=js&"
import style0 from "./ordersum.vue?vue&type=style&index=0&id=4d2b3ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b3ade",
  null
  
)

export default component.exports